import { Tooltip } from 'antd';
import { Star06 } from '@insight-health-ai/roseate/icons';
import { Button } from '@insight-health-ai/roseate/components';
import { useSelector } from 'react-redux';
import { usePermissionEntitlements } from '@frontegg/react';
import { isAllowedToGenerateSummary } from '../PastEncounter/permissions';
import { useMemo } from 'react';

const GenerateSummaryVoiceBar = ({
  encounterPhase = 'in-visit',
  handleCompleteRecording,
  className,
}) => {
  const { isEncounterCompleteLoading } = useSelector(
    (state) => state?.encounterState
  );
  const { isEntitled: canGenerateInVisitSummary } = usePermissionEntitlements(
    'encounter.in-visit.generate'
  );
  const { isEntitled: canGeneratePreChartSummary } = usePermissionEntitlements(
    'encounter.pre-chart.generate'
  );
  const { isEntitled: canGenerateAfterVisitSummary } =
    usePermissionEntitlements('encounter.after-visit.generate');

  const { disabled, tooltipText } = useMemo(() => {
    // Determine if disabled due to permissions
    let isPermissionDisabled = !isAllowedToGenerateSummary({
      encounterPhase,
      canGenerateInVisitSummary,
      canGeneratePreChartSummary,
      canGenerateAfterVisitSummary,
    });

    const disabled = isPermissionDisabled;
    let tooltipText = '';
    if (isPermissionDisabled) {
      tooltipText = 'You do not have permission for this action.';
    }

    return { disabled, tooltipText };
  }, [
    encounterPhase,
    canGenerateInVisitSummary,
    canGeneratePreChartSummary,
    canGenerateAfterVisitSummary,
  ]);

  // Define the button element
  const button = (
    <Button
      block
      size="lg"
      id="generate_note"
      onClick={handleCompleteRecording}
      disabled={disabled}
      loading={isEncounterCompleteLoading}
      icon={<Star06 />}
      className={className}
    >
      Generate note
    </Button>
  );

  // Conditionally wrap with Tooltip only if disabled and tooltip text exists
  return disabled && tooltipText ? (
    <Tooltip title={tooltipText} placement="bottom">
      <span className="w-full">{button}</span>
    </Tooltip>
  ) : (
    button
  );
};

export default GenerateSummaryVoiceBar;
